(() => {
  const run = () => {
    const path = window.location.pathname;
    const policy = document.querySelector('.shopify-policy__container');
    if (policy) document.documentElement.classList.add('ea-policy-page');

    const ensurePolicyTitle = (label) => {
      const titleBox = document.querySelector('.shopify-policy__title');
      if (!titleBox) return;
      if (!titleBox.querySelector('.ea-policy-eyebrow')) {
        const eyebrow = document.createElement('p');
        eyebrow.className = 'ea-policy-eyebrow';
        eyebrow.textContent = 'Customer care';
        titleBox.prepend(eyebrow);
      }
      let h1 = titleBox.querySelector('h1');
      if (!h1) {
        h1 = document.createElement('h1');
        Array.from(titleBox.childNodes).forEach((node) => {
          if (!(node.nodeType === 1 && node.classList.contains('ea-policy-eyebrow'))) node.remove();
        });
        titleBox.appendChild(h1);
      }
      h1.textContent = label;
      document.title = document.title.replace(/^Terms of service/i, 'Terms of Service').replace(/^Privacy policy/i, 'Privacy Policy');
    };

    const appendLinkedText = (el, text) => {
      const replacements = [
        { token: '[LINK TO REFUND POLICY]', text: 'Waiver & Participation Agreement', href: '/pages/waiver-participation-agreement' },
        { token: '[LINK TO PRIVACY POLICY]', text: 'Privacy Policy', href: '/policies/privacy-policy' },
        { token: '[LINK TO TERMS OF SERVICE]', text: 'Terms of Service', href: '/policies/terms-of-service' },
        { token: 'https://earthartspottery.com/policies/refund-policy', text: 'https://earthartspottery.com/policies/refund-policy', href: '/policies/refund-policy' },
        { token: 'https://earthartspottery.com/policies/privacy-policy', text: 'https://earthartspottery.com/policies/privacy-policy', href: '/policies/privacy-policy' }
      ];
      let remaining = text;
      while (remaining) {
        const next = replacements.map((r) => ({ ...r, index: remaining.indexOf(r.token) })).filter((r) => r.index >= 0).sort((a, b) => a.index - b.index)[0];
        if (!next) { el.appendChild(document.createTextNode(remaining)); break; }
        if (next.index > 0) el.appendChild(document.createTextNode(remaining.slice(0, next.index)));
        const a = document.createElement('a');
        a.href = next.href;
        a.textContent = next.text;
        el.appendChild(a);
        remaining = remaining.slice(next.index + next.token.length);
      }
    };

    const sectionTitle = (line) => line === 'OVERVIEW'
      ? 'Overview'
      : line.toLowerCase().replace(/\b\w/g, (m) => m.toUpperCase()).replace(/\b(And|Of|The|To|Or|In)\b/g, (m) => m.toLowerCase()).replace(/\bVat\b/g, 'VAT');

    if (path === '/policies/terms-of-service') {
      ensurePolicyTitle('Terms of Service');
      const body = document.querySelector('.shopify-policy__body');
      if (!body) return;
      body.classList.add('ea-policy-formatted', 'ea-terms-formatted');
      const seen = new Set();
      const lines = (body.innerText || '').split('\n').map((line) => line.trim()).filter(Boolean).flatMap((line) => {
        const cleaned = line
          .replace(/hello@earthartslb\.com/gi, 'hello@earthartspottery.com')
          .replace(/ron@perceptable\.com/gi, 'hello@earthartspottery.com')
          .replace(/Questions about the Terms of Service should be sent to us at .+?\.?$/i, 'Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any of the rights available to you, please call (516) 432-9000 or email us at hello@earthartspottery.com or contact us at 162 W Park Ave, Long Beach, NY, 11561, US')
          .replace(/\s+/g, ' ')
          .trim();
        if (
          /^\[INSERT .+\]$/i.test(cleaned) ||
          /^\[INSERT VAT NUMBER\]\s+OVERVIEW$/i.test(cleaned) ||
          /^Our contact information is posted below:?$/i.test(cleaned) ||
          /^hello@earthartspottery\.com$/i.test(cleaned)
        ) return [];
        const key = cleaned.toLowerCase();
        if (seen.has(key)) return [];
        seen.add(key);
        return [cleaned];
      });
      body.innerHTML = '';
      lines.forEach((line) => {
        if (line === 'OVERVIEW' || /^SECTION\s+\d+\s+-\s+/i.test(line)) {
          const h2 = document.createElement('h2');
          h2.textContent = sectionTitle(line);
          body.appendChild(h2);
        } else {
          const p = document.createElement('p');
          appendLinkedText(p, line);
          body.appendChild(p);
        }
      });
    }

    if (path === '/policies/refund-policy') {
      const body = document.querySelector('.shopify-policy__body');
      if (body) body.classList.add('ea-policy-formatted', 'ea-refund-formatted');
    }

    if (path === '/policies/privacy-policy') {
      ensurePolicyTitle('Privacy Policy');
      const body = document.querySelector('.shopify-policy__body');
      if (!body) return;
      body.classList.add('ea-policy-formatted', 'ea-privacy-formatted');
      const labels = [
        ['Identifiers', 'Payment information', 'Account information', 'Shopping information', 'Customer support information', 'Device information', 'Usage information'],
        ['Directly from you', 'Automatically through the Services', 'From service providers', 'From partners and third parties'],
        ['Providing products and services', 'Marketing and advertising', 'Security and fraud prevention', 'Customer support'],
        ['Vendors and service providers', 'Business and marketing partners', 'Affiliates', 'Legal and business transactions']
      ];
      body.querySelectorAll('ul').forEach((ul, listIndex) => {
        if (!labels[listIndex]) return;
        ul.querySelectorAll('li').forEach((li, itemIndex) => {
          if (!li.textContent.trim()) {
            li.remove();
            return;
          }
          const strong = li.querySelector('strong') || li.insertBefore(document.createElement('strong'), li.firstChild);
          const label = labels[listIndex][itemIndex];
          if (label) strong.textContent = `${label}: `;
        });
      });
      body.innerHTML = body.innerHTML.replace(/please call\s+or email/gi, 'please call (516) 432-9000 or email').replace(/516-432-9000/g, '(516) 432-9000');
    }

    if (path === '/pages/waiver-participation-agreement') {
      document.documentElement.classList.add('ea-waiver-page');
      const body = document.querySelector('.ea-pagecontent__body');
      if (!body) return;
      body.innerHTML = body.innerHTML.replace(/(<h[2-4][^>]*>\s*)Paint Your Own Pottery \(PYOP\)(\s*<\/h[2-4]>\s*<p>\s*Unused and unopened retail items)/i, '$1Retail items$2');
      const makeEl = (tag, html) => {
        const el = document.createElement(tag);
        el.innerHTML = html;
        return el;
      };
      const makeList = (items) => {
        const ul = document.createElement('ul');
        ul.className = 'ea-waiver-list';
        items.forEach((html) => ul.appendChild(makeEl('li', html)));
        return ul;
      };
      const findStrongParagraph = (pattern) => Array.from(body.querySelectorAll('p')).find((p) => {
        const strong = p.querySelector('strong');
        return strong && pattern.test(strong.textContent || '');
      });
      const replaceRange = (startNode, endNode, nodes) => {
        if (!startNode || !endNode || startNode === endNode) return;
        const parent = startNode.parentNode;
        nodes.forEach((node) => parent.insertBefore(node, startNode));
        let current = startNode;
        while (current && current !== endNode) {
          const next = current.nextSibling;
          current.remove();
          current = next;
        }
      };
      const section4 = findStrongParagraph(/^\s*4\.\s*Cancellation\s*&\s*Rescheduling Policy/i);
      const section6 = findStrongParagraph(/^\s*6\.\s*Finished Work\s*&\s*Pick-Up/i);
      const firstSummary = Array.from(body.querySelectorAll('p')).find((p) => /^\s*Summary\s*$/i.test(p.textContent || ''));
      if (firstSummary) {
        const h2 = document.createElement('h2');
        h2.className = 'ea-waiver-summary-title';
        h2.textContent = 'Summary';
        firstSummary.replaceWith(h2);
      }
      Array.from(body.querySelectorAll('h2,h3,h4')).forEach((heading) => {
        if (/^\s*EAPS Waiver\s*&\s*Participation Agreement\s*$/i.test(heading.textContent || '')) heading.remove();
      });
      Array.from(body.querySelectorAll('p')).forEach((p) => {
        if (/^\s*Please review the full waiver below for complete details\.?\s*$/i.test(p.textContent || '')) p.remove();
      });
      Array.from(body.querySelectorAll('p')).forEach((p) => {
        const strong = p.querySelector(':scope > strong:first-child');
        if (!strong || !/^\s*\d+\.\s+/.test(strong.textContent || '')) return;
        const h2 = document.createElement('h2');
        h2.textContent = strong.textContent.trim();
        const html = p.innerHTML
          .replace(/^\s*<strong[^>]*>[\s\S]*?<\/strong>\s*(<br\s*\/?>)?/i, '')
          .split(/<br\s*\/?>/i)
          .map((part) => part.trim())
          .filter(Boolean);
        p.before(h2);
        html.forEach((part) => p.before(makeEl('p', part)));
        p.remove();
      });
      body.classList.add('ea-waiver-formatted');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
